import React, { useRef, useEffect } from 'react';
import { authService } from './services/auth-service';
import { api } from './api';
import { toast } from 'react-toastify';
import * as R from 'ramda';
import { Button } from 'Components/nui';
import { FormattedMessage } from 'react-intl';

export default () => {
  const ref = useRef(null);

  const clickYes = async () => {
    toast.dismiss(ref.current);
    const response = await api.postData('/user/trusted-browsers', {});
    authService.saveTrusted(
      R.pathOr('', ['trusted-browser', 'code'], response)
    );
  };

  const clickNo = () => {
    toast.dismiss(ref.current);
    authService.saveTrusted('');
  };

  useEffect(() => {
    const trusted = authService.loadTrusted();
    if (trusted === null) {
      ref.current = toast(
        <>
          <h3>
            <FormattedMessage
              id="trusted-browser-title"
              defaultMessage="New browser"
            />
          </h3>
          <p>
            <FormattedMessage
              id="trusted-browser-question"
              defaultMessage="Do you want to add this browser to your trusted list?"
            />
          </p>
          <p>
            <FormattedMessage
              id="trusted-browser-description"
              defaultMessage="Enabling this will allow you to {quotedText} with this browser."
              values={{
                quotedText: (
                  <FormattedMessage
                    id="trusted-browser-auto-signin"
                    defaultMessage="auto sign in from emails"
                  />
                ),
              }}
            />
          </p>
          <Button
            onClick={clickYes}
            type="primary"
            size="small"
            className="bold mr-10"
          >
            <FormattedMessage id="trusted-browser-yes" defaultMessage="Yes" />
          </Button>
          <Button onClick={clickNo} size="small">
            <FormattedMessage id="trusted-browser-no" defaultMessage="No" />
          </Button>
        </>,
        {
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          autoClose: false,
        }
      );
    }
  }, []);
};
